import React from "react";
import { motion } from "framer-motion";
import { CheckIcon, ShieldCheckIcon, ZapIcon, FileTextIcon } from "lucide-react";
import { CountdownUrgency } from "./CountdownUrgency";
import { BuyButton } from "./BuyButton";
interface FinalOfferProps {
  onBuy: () => void;
}
const SUMMARY = [{
  label: "Padel Zurdo Pro — 7 Tomos completos",
  price: "20€"
}, {
  label: "+15 drills y +20 recursos tácticos",
  price: "Incluido"
}, {
  label: "10 Bonos exclusivos (hoy gratis)",
  price: "0€"
}, {
  label: "Plan de entrenamiento de 8 semanas",
  price: "Incluido"
}];
export function FinalOffer({
  onBuy
}: FinalOfferProps) {
  return <section id="compra" className="scroll-mt-4 px-5 py-10" data-id="element-134" data-mp="203uxwph1u1pf">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="rounded-3xl border border-[#d4ff00]/40 bg-[#0b0b0b]/90 p-5 shadow-[0_0_40px_-10px_rgba(212,255,0,0.35)] backdrop-blur" data-id="element-135" data-mp="1v51ll0di0gqu">
        <p className="text-center text-[13px] font-bold uppercase tracking-widest text-[#d4ff00]" data-id="element-136" data-mp="1pp1tlo980it">
          Oferta de lanzamiento
        </p>
        <h2 className="mt-1 text-center font-display text-3xl uppercase leading-none text-white" data-id="element-137" data-mp="6pbglzjqdotq">
          Empieza a jugar como el zurdo que eres
        </h2>

        <div className="mt-5" data-id="element-138" data-mp="gn90kauk4zgj">
          <CountdownUrgency data-id="element-139" data-mp="gnhfe8a8qeud" />
        </div>

        {/* Order summary */}
        <div className="mt-5 rounded-2xl border border-white/10 bg-black/40 p-4" data-id="element-140" data-mp="koui49i1e1x2">
          <p className="mb-3 text-[13px] font-bold uppercase tracking-wide text-white/60" data-id="element-141" data-mp="pn4gesz25imw">
            Resumen del pedido
          </p>
          <ul className="flex flex-col gap-2.5" data-id="element-142" data-mp="uf5soew879cx">
            {SUMMARY.map((row, i) => <li key={i} className="flex items-start justify-between gap-3" data-id="element-143" data-mp="zc5v8ftv9tza" data-mpi={i}>
                <span className="flex items-start gap-2 text-[13px] text-white/80" data-id="element-144" data-mp="14ctxjxnjpx8t">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#d4ff00]" data-id="element-145" data-mp="18dvo7q3ed0z6" />
                  {row.label}
                </span>
                <span className="shrink-0 text-[13px] font-semibold text-white/60" data-id="element-146" data-mp="35fl1fkintpql">
                  {row.price}
                </span>
              </li>)}
          </ul>

          <div className="mt-4 flex items-end justify-between border-t border-white/10 pt-4" data-id="element-147" data-mp="3e7d8rmce0iqy">
            <span className="text-[13px] font-bold uppercase text-white/60" data-id="element-148" data-mp="39flf32xxpwwl">
              Total hoy
            </span>
            <div className="flex items-baseline gap-2" data-id="element-149" data-mp="3o3ye68sbjvvb">
              <span className="text-lg text-white/40 line-through" data-id="element-150" data-mp="3j5wv3nuw7wju">50€</span>
              <span className="font-display text-4xl leading-none text-[#d4ff00]" data-id="element-151" data-mp="3j80vvwxhwffw">
                20€
              </span>
            </div>
          </div>
        </div>

        <div className="mt-5" data-id="element-152" data-mp="3t5fbxvfib27o">
          <BuyButton label="Quiero dominar mi zurda" onClick={onBuy} data-id="element-153" data-mp="3t1ztcimmjb1i" />
        </div>

        <div className="mt-4 flex items-center justify-center gap-4 text-[11px] text-white/50" data-id="element-154" data-mp="22ryb0gcctmus">
          <span className="flex items-center gap-1" data-id="element-155" data-mp="1yrnwugeerq4u">
            <FileTextIcon className="h-3.5 w-3.5" data-id="element-156" data-mp="1olml9u2vok1l" /> 100% PDF
          </span>
          <span className="flex items-center gap-1" data-id="element-157" data-mp="1snq9ljanbj4a">
            <ZapIcon className="h-3.5 w-3.5" data-id="element-158" data-mp="1smgacqs244w2" /> Entrega inmediata
          </span>
          <span className="flex items-center gap-1" data-id="element-159" data-mp="1ex4lng6c4izj">
            <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-160" data-mp="1euigtoatwhl0" /> Pago único
          </span>
        </div>
      </motion.div>
    </section>;
}